import 'console-polyfill'
import 'es5-shim'
import 'picturefill'

import FastClick from 'fastclick'
import $ from 'jquery'

// plugins
import './plugins/icheck'

// components
import './components/range'
import './components/gallery'
import './components/number-input'
import './components/navigation'
import './components/products'
import './components/moving-products'
import './components/logos'
import './components/totop'

FastClick.attach(document.body);

$('input[type=checkbox], input[type=radio]').iCheck();



// WEBPACK FOOTER //
// ./src/js/app.js